import React from 'react';
import ReactDOM from 'react-dom';
import PasswordChecker from './components/passwordChecker';

let mountPoint;

function render(props) {
    ReactDOM.render(React.createElement(PasswordChecker, props), mountPoint);
}

export default function(data, callbacks = {}) {
    if (!data || !data.details || !data.details.scanResult === 'FAIL') {
        return;
    }

    if (!mountPoint) {
        mountPoint = document.createElement('div');
        document.body.appendChild(mountPoint);
    }

    let onIgnore = () => {
        if (callbacks.onIgnore) callbacks.onIgnore();
        render({data, isOpen: false});
    };

    let onClose = () => {
        if (callbacks.onClose) callbacks.onClose();
        render({data, isOpen: false});
    };

    render({data, onIgnore, onClose, isOpen: true});
}



/** WEBPACK FOOTER **
 ** ./js/app/password_checker/index.js
 **/